import {createApp} from 'vue';
import AddToProjectModal from '../../components/AddToProjectModal.vue';

document.addEventListener('DOMContentLoaded', () => {
    const buttons = document.querySelectorAll('.open-add-to-project-modal[data-config]');
    if (buttons.length === 0) {
        return;
    }

    const el = document.createElement('div');
    document.body.appendChild(el);
    createApp(AddToProjectModal).mount(el);

    for (const button of buttons) {
        button.addEventListener('click', (e) => {
            e.preventDefault();
            window.openAddToProjectModal(JSON.parse(button.dataset.config));
        });
    }
});
